const BHAvailabilityInStore = {
	BHAvailabilityInStore: {
		defaultProps: {
			dialogProps: {
				showButtonClose: true,
			},
			listProps: {
				itemHeight: 300,
			},
			mapProps: {},
		},
	},
}
export default BHAvailabilityInStore
